
import { getAllusersApi, getLoggedUserApi } from '../../api/users/usersApi';
import Types from '../types';
import { setGlobalLoader } from './commonAction';

export const getAllUsers = () => {
    return async function (dispatch) {
        dispatch(setGlobalLoader(true))
        const result = await getAllusersApi()
        const activeUsers = result?.filter(user => user.active) || []
        dispatch({
            type: Types.ALL_USERS,
            payload: activeUsers
        });
        dispatch(setGlobalLoader(false))
    }
}

export const getLoggedUser = (email) => {
    return async function (dispatch) {
        const result = await getLoggedUserApi(email)
        dispatch({
            type: Types.LOGGED_USER,
            payload: result
        });
        dispatch(setGlobalLoader(false))
    }
}

